import accLogin from '@/views/accMgt/login'
import Home from '@/views/layout/home'
import membersList from '@/views/accMgt/membersList'
import questionnaireList from '@/views/accMgt/questionnaireList'
import enterpriseMember from '@/views/accMgt/enterpriseMember'
import enterpriseMemberDetail from '@/views/accMgt/enterpriseMember/detail'
const routes = [
  {
    path: '/acc/login',
    name: '登录',
    component: accLogin,
  },
  {
    path: '/',
    redirect: '/acc/membersList',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/acc/membersList',
        name: 'membersList',
        component: membersList,
      },
      {
        path: '/acc/questionnaireList',
        name: 'questionnaireList',
        component: questionnaireList,
      },
      {
        path: '/acc/enterpriseMember',
        name: 'enterpriseMember',
        component: enterpriseMember,
      },
      {
        path: '/acc/enterpriseMemberDetail',
        name: 'EnterpriseMemberDetail',
        component: enterpriseMemberDetail,
      },
    ]
  }
]
export default routes
